export const formatDate = value => {
  if (!value) {
    return '';
  } else {
    const options = { day: 'numeric', year: 'numeric', month: 'numeric' };
    return new Intl.DateTimeFormat('default', options).format(new Date(value));
  }
};
